import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export const taskSummaryGridColumns = () => [
    {
        field: 'attribute',
        headerName: apiProvider.getEntityUpper() + ' Attribute',
        width: 250,
    },
    {
        field: 'tasks',
        headerName: apiProvider.getEntityUpper() + 's',
        filter: 'agTextColumnFilter',
        width: 120,
        valueFormatter: ({ value }) =>
            apiProvider.formatNumber({ count: value }),
    },
    {
        field: 'perc_total_tasks',
        headerName: '% ' + apiProvider.getEntityLower() + 's',
        filter: 'agNumberColumnFilter',
        width: 130,
        valueFormatter: ({ value }) =>
            apiProvider.formatPercentage({ perc: value, decimals: 1  }),
    },
    {
        field: 'avg_duration',
        headerName: 'Avg Duration',
        width: 130,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
    },
    {
        field: 'min_duration',
        headerName: 'Min Duration',
        width: 130,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: true,
    },
    {
        field: 'max_duration',
        headerName: 'Max Duration',
        width: 130,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: true,
    },
    {
        field: 'avg_duration_days',
        headerName: 'Avg Duration (days)',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'avg_duration_hrs',
        headerName: 'Avg Duration (hours)',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'std_deviation',
        headerName: 'Std Deviation',
        width: 130,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: false,
    },
    {
        field: 'std_deviation_days',
        headerName: 'Std Deviation (days)',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'std_deviation_hrs',
        headerName: 'Std Deviation (hours)',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'worklogs',
        headerName: 'Worklogs',
        filter: 'agNumberColumnFilter',
        hide: true,
    },
    {
        field: 'time_spent',
        headerName: 'Time Spent',
        width: 130,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: true,
    },
    {
        field: 'avg_time_spent',
        headerName: 'Avg Time Spent',
        width: 130,
        valueFormatter: ({ value }) =>
            apiProvider.formatDuration({ seconds: value }),
        hide: false,
    },
];
